// Messages courts de Bongo — style sagesse calme, UI inline
export const bongoMessages = {
  fr: [
    "Observe. Crée. Répète.",
    "Chaque couleur posée est une intention.",
    "Le processus est l’œuvre.",
    "Ici, pas de perfection requise.",
    "Crée pour toi, d’abord.",
    "Un trait à la fois.",
    "L’art n’attend pas la perfection.",
    "Laisse venir.",
    "Ce que tu crées compte.",
    "Ton regard est unique."
  ],
  en: [
    "Observe. Create. Repeat.",
    "Every color you place is an intention.",
    "The process is the work.",
    "Here, perfection isn't required.",
    "Create for yourself, first.",
    "One stroke at a time.",
    "Art doesn't wait for perfection.",
    "Let it come.",
    "What you create matters.",
    "Your vision is unique."
  ]
};

export function getRandomBongoMessage(language = 'fr') {
  const messages = bongoMessages[language] || bongoMessages.fr;
  return messages[Math.floor(Math.random() * messages.length)];
}

// ─── Phrases du jour — style sagesse calme et bienveillante ─────────────────

export const bongoPhrasesJour = {
  fr: [
    // Moment présent
    "Ce moment, là, maintenant — c’est tout ce qu’il y a.",
    "Tu n’as pas besoin d’aller quelque part. Tu es déjà là.",
    "Respire. Tout le reste peut attendre.",
    "Le présent est le seul endroit où tu vis vraiment.",
    "Ici. Maintenant. C’est assez.",
    "Ce moment passera. Mais il aura existé.",
    "Il suffit parfois de s’asseoir et de ne rien vouloir.",
    "Être présent, c’est le cadeau le plus rare qu’on puisse s’offrir.",
    "Fais une chose. Complètement. Le reste suit.",

    // Acceptation & lâcher prise
    "Rien n’est permanent. Ni les difficultés, ni la joie. Alors savoure.",
    "Observe tes pensées comme des nuages. Elles passent.",
    "Accueille ce qui vient. Laisse partir ce qui va.",
    "Lâcher prise n’est pas abandonner. C’est faire confiance.",
    "Ce qui est, est. Ce qui passe, passe.",
    "Pose tes attentes. Reprends juste le crayon.",
    "Tout est toujours en train de se transformer. Toi aussi.",
    "Ne cherche pas le chemin parfait. Marche sur celui qui est là.",

    // Créativité & fluidité
    "L’eau ne force pas son chemin. Elle le trouve.",
    "La vraie créativité naît du calme, pas de la course.",
    "Les grandes œuvres naissent de petits gestes répétés.",
    "Un geste fait avec soin vaut mille gestes faits à la hâte.",
    "Ce qui fleurit prend son temps.",
    "L’imperfection est la signature du vivant.",
    "Ce que tu crées avec soin restera, d’une façon ou d’une autre.",
    "Commence. Le reste vient de lui-même.",
    "La beauté ne crie pas. Elle s’installe doucement.",

    // Calme & sérénité
    "Le calme n’est pas l’absence de bruit. C’est ta présence en toi.",
    "La paix ne se trouve pas. Elle se retrouve, à chaque souffle.",
    "La sérénité n’est pas une récompense. C’est une pratique.",
    "Le silence entre les notes fait la musique.",
    "Les racines profondes supportent les tempêtes sans bouger.",
    "Ce qui est planté dans le calme grandit lentement, mais solidement.",
    "Un moment de silence peut tout réorienter.",

    // Valeur & rythme personnel
    "Ta valeur ne dépend pas de ce que tu produis.",
    "Ton rythme est le bon. Pas celui des autres.",
    "Tu es déjà complet. Même en cours de route.",
    "La douceur est aussi une forme de force.",
    "Ce que tu cherches au loin est souvent juste ici.",
    "Rien ne t’est volé si tu apprécies ce qui est là.",
    "Le chemin est la destination.",

    // Souffle & recommencement
    "Chaque respiration est un nouveau départ.",
    "Moins d’effort, parfois, c’est plus de fluidité.",
    "Le repos n’est pas une pause. Il fait partie du travail.",
    "Reprendre, c’est aussi avancer.",
    "Aujourd’hui a le droit d’être simple.",
    "Un tout petit pas compte autant qu’un grand.",
    "Ce qui recommence n’a jamais vraiment arrêté."
  ],
  en: [
    // Present moment
    "This moment, right now — it's all there is.",
    "You don't need to go anywhere. You're already here.",
    "Breathe. Everything else can wait.",
    "The present is the only place you truly live.",
    "Here. Now. It's enough.",
    "This moment will pass. But it will have existed.",
    "Sometimes it's enough to just sit and want nothing.",
    "Being present is the rarest gift you can give yourself.",
    "Do one thing. Fully. The rest follows.",

    // Acceptance & letting go
    "Nothing is permanent. Not the hard parts, not the good ones. Savor both.",
    "Watch your thoughts like clouds. They pass.",
    "Welcome what comes. Release what goes.",
    "Letting go isn't giving up. It's trusting.",
    "What is, is. What passes, passes.",
    "Let go of expectations. Just pick up the pencil.",
    "Everything is always transforming. Including you.",
    "Don't look for the perfect path. Walk the one that's there.",

    // Creativity & flow
    "Water doesn't force its way. It finds it.",
    "True creativity comes from stillness, not from rushing.",
    "Great works are born from small, repeated gestures.",
    "One gesture made with care is worth a thousand rushed ones.",
    "What blooms takes its time.",
    "Imperfection is the mark of the living.",
    "What you create with care stays, in one way or another.",
    "Begin. The rest comes on its own.",
    "Beauty doesn't shout. It settles in quietly.",

    // Calm & serenity
    "Calm isn't the absence of noise. It's your presence within yourself.",
    "Peace isn't found. It's rediscovered, with each breath.",
    "Serenity isn't a reward. It's a practice.",
    "The silence between notes is what makes music.",
    "Deep roots hold steady through any storm.",
    "What is planted in stillness grows slowly, but deeply.",
    "A moment of silence can reorient everything.",

    // Worth & personal rhythm
    "Your worth doesn't depend on what you produce.",
    "Your pace is the right pace. Not someone else's.",
    "You are already whole. Even while in progress.",
    "Gentleness is also a form of strength.",
    "What you seek far away is often right here.",
    "Nothing is taken from you when you appreciate what's here.",
    "The path is the destination.",

    // Breath & renewal
    "Every breath is a fresh start.",
    "Less effort, sometimes, means more flow.",
    "Rest isn't a pause. It's part of the work.",
    "Starting again is also moving forward.",
    "Today is allowed to be simple.",
    "A very small step counts as much as a large one.",
    "What begins again never truly stopped."
  ]
};

/**
 * Retourne la phrase du jour de Bongo.
 * Stable pendant 24h via localStorage — change automatiquement le lendemain.
 */
export function getDailyBongoMessage(language = 'fr') {
  const today = new Date().toISOString().slice(0, 10); // 'YYYY-MM-DD'
  const phrases = bongoPhrasesJour[language] || bongoPhrasesJour.fr;

  try {
    const stored = localStorage.getItem('bongo_daily_phrase');
    if (stored) {
      const { date, index } = JSON.parse(stored);
      if (date === today) {
        return phrases[index % phrases.length];
      }
    }
  } catch {
    // localStorage indisponible — on continue avec une phrase aléatoire
  }

  const index = Math.floor(Math.random() * phrases.length);
  try {
    localStorage.setItem('bongo_daily_phrase', JSON.stringify({ date: today, index }));
  } catch {
    // silence
  }

  return phrases[index];
}
